import { createAction } from "@logicsoftware/redux-toolkit";
import { put, takeEvery } from "redux-saga/effects";
import { LSHelper } from "~/EasyProjectsCommon/LSHelper";
import { MENU_SPACE_KEY } from "~/Redux/Spaces/consts";
import { setMenuSpace } from "~/Redux/Spaces/state/spacesSlice";

export const saveMenuSpace = createAction("SPACES/SAVE_MENU_SPACE", (spaceId: number) => ({
    payload: spaceId,
}));

export function* watchSaveMenuSpaceSaga() {
    yield takeEvery(saveMenuSpace, saveMenuSpaceHandler);
}

function* saveMenuSpaceHandler({ payload }: ReturnType<typeof saveMenuSpace>) {
    yield put(setMenuSpace(payload));
    LSHelper.reSet(MENU_SPACE_KEY, payload);
}
